import { ActionContext, Module } from "vuex";

import { RootState } from "@/store/root";

export interface Alert {
  type: "danger" | "success" | "info";
  message: string;
}

export interface AlertsState {
  list: Alert[];
}

export const alerts: Module<AlertsState, RootState> = {
  state: {
    list: []
  },
  namespaced: true,
  mutations: {
    PUSH(state: AlertsState, alert: Alert) {
      state.list.push(alert);
    },
    CLEAR(state: AlertsState) {
      state.list = [];
    }
  },
  actions: {
    flash(context: ActionContext<AlertsState, RootState>, alert: Alert) {
      context.commit("PUSH", alert);
    },
    get(context: ActionContext<AlertsState, RootState>) {
      const result = [...context.state.list];

      context.commit("CLEAR");

      return result;
    }
  }
};
